import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreLabel?: string;
  moreTo?: string;
  icon?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  title,
  subtitle,
  moreLabel,
  moreTo,
  icon,
  children,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6 md:mb-8">
      <div>
        <h2 className="flex items-center gap-2.5 text-xl md:text-2xl font-bold text-foreground-950">
          {icon && (
            <span className="w-8 h-8 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center text-lg">
              <i className={icon}></i>
            </span>
          )}
          {title}
        </h2>
        {subtitle && (
          <p className="mt-2 text-sm text-foreground-600">{subtitle}</p>
        )}
      </div>
      {children}
      {moreLabel && moreTo && (
        <Link
          to={moreTo}
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}